import React from 'react'
import PrivateRoutes from '../Route'
import List from '../../pages/Cache/CacheRegister/List'
import { CustomSwitch } from '../../components/CustomSwitch'

export const CacheRegisterRouter = (): JSX.Element => (
  <CustomSwitch>
    <PrivateRoutes path="/cache" exact component={List} />
  </CustomSwitch>
)
